<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: 'PartnerView'
}
</script>

<style scoped>

</style>
